import React from "react";
import MainDesign from "../MainDesign";
import Spinner from "../../components/common/Spinner";

interface LoadingPageProps {
    styles?: string
    minHeight?: string
    useGradientBackground?: boolean  // true = full page with gradient, false = transparent (for embedded use)
}

export default function LoadingPage(props: LoadingPageProps) {
    const {styles, minHeight = '70vh', useGradientBackground = false} = props;

    // Transparent background - for embedded loaders inside components with existing backgrounds
    if (!useGradientBackground) {
        return (
            <div
                className={`d-flex align-items-center justify-content-center ${styles || ''}`}
                style={{minHeight}}
            >
                <Spinner/>
            </div>
        );
    }

    // Full page loader with gradient background
    return (
        <MainDesign minHeight={minHeight} containerStyles={styles || 'pt-40'} useGradientBackground={true}>
            <div className='mb-7 text-center mw-md mx-auto'>
                <div className="d-flex justify-content-center">
                    <Spinner/>
                </div>
            </div>
        </MainDesign>
    );
}